import React, {useEffect, useState} from 'react';

const StatusFilters = ({selectedStatuses, setSelectedStatuses, withLabel = true, ...props}) => {
    const [uploaded, setUploaded] = useState(true);
    const [duplicate, setDuplicate] = useState(true);
    const [excluded, setExcluded] = useState(true);
    const [created, setCreated] = useState(true);
    const [update, setUpdate] = useState(true);
    const [updated, setUpdated] = useState(true);
    const [splited, setSplited] = useState(true);
    const [split, setSplit] = useState(true);
    const [unite, setUnite] = useState(true);
    const [united, setUnited] = useState(true);

    useEffect(() => {
        const statuses = [];
        if (uploaded) {
            statuses.push('UPLOADED');
        }
        if (duplicate) {
            statuses.push('DUPLICATE');
        }
        if (excluded) {
            statuses.push('EXCLUDED');
        }
        if (created) {
            statuses.push('CREATED');
        }
        if (update) {
            statuses.push('UPDATE');
        }
        if (updated) {
            statuses.push('UPDATED');
        }
        if (splited) {
            statuses.push('SPLITED');
        }
        if (split) {
            statuses.push('SPLIT');
        }
        if (unite) {
            statuses.push('UNITE');
        }
        if (united) {
            statuses.push('UNITED');
        }
        setSelectedStatuses(statuses);
    }, [uploaded, duplicate, excluded, created, update, updated, splited, split, unite, united]);

    return (
        <div {...props}>
            {withLabel && <label htmlFor="filter" className="ml-3 mb-1 block text-sm font-medium text-gray-700">Statuses</label>}
            <div className="flex flex-wrap">
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_uploaded"
                        name="checkbox_uploaded"
                        type="checkbox"
                        checked={uploaded}
                        onChange={() => setUploaded((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">Uploaded</div>
                </div>
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_duplicate"
                        name="checkbox_duplicate"
                        type="checkbox"
                        checked={duplicate}
                        onChange={() => setDuplicate((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">Duplicate</div>
                </div>
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_excluded"
                        name="checkbox_excluded"
                        type="checkbox"
                        checked={excluded}
                        onChange={() => setExcluded((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">Excluded</div>
                </div>
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_created"
                        name="checkbox_created"
                        type="checkbox"
                        checked={created}
                        onChange={() => setCreated((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">Created</div>
                </div>
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_update"
                        name="checkbox_update"
                        type="checkbox"
                        checked={update}
                        onChange={() => setUpdate((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">Update</div>
                </div>
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_updated"
                        name="checkbox_updated"
                        type="checkbox"
                        checked={updated}
                        onChange={() => setUpdated((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">Updated</div>
                </div>
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_splited"
                        name="checkbox_splited"
                        type="checkbox"
                        checked={splited}
                        onChange={() => setSplited((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">Splited</div>
                </div>
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_split"
                        name="checkbox_split"
                        type="checkbox"
                        checked={split}
                        onChange={() => setSplit((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">Split</div>
                </div>
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_unite"
                        name="checkbox_unite"
                        type="checkbox"
                        checked={unite}
                        onChange={() => setUnite((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">Unite</div>
                </div>
                <div className="flex h-6 items-center">
                    <input
                        id="checkbox_united"
                        name="checkbox_united"
                        type="checkbox"
                        checked={united}
                        onChange={() => setUnited((value) => !value)}
                        className="h-6 w-6 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                    />
                    <div className="mx-2">United</div>
                </div>
            </div>
        </div>
    );
};

export default StatusFilters;
